export const ACCESS_TOKEN = 'access_token';

export const REFRESH_TOKEN = 'refresh_token';

export const ACCESS_TOKEN_EXPIRE_TIME = 'access_token_expire_time';

export const LOGIN_PATH = '/login';